function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Camera Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13,0.5 C13.1326082,0.5 13.2597852,0.55267842 13.3535534,0.646446609 L15.2071068,2.5 L17.001,2.5 C18.3811424,2.5 19.5,3.61885763 19.5,4.999 L19.5,13.001 C19.5,14.3811424 18.3811424,15.5 17.001,15.5 L2.999,15.5 C1.61885763,15.5 0.5,14.3811424 0.5,13.001 L0.5,4.999 C0.5,3.61885763 1.61885763,2.5 2.999,2.5 L4.79289322,2.5 L6.64644661,0.646446609 C6.7402148,0.55267842 6.86739176,0.5 7,0.5 L13,0.5 Z M12.7928932,1.5 L7.20710678,1.5 L5.35355339,3.35355339 C5.2597852,3.44732158 5.13260824,3.5 5,3.5 L2.999,3.5 C2.17114237,3.5 1.5,4.17114237 1.5,4.999 L1.5,13.001 C1.5,13.8288576 2.17114237,14.5 2.999,14.5 L17.001,14.5 C17.8288576,14.5 18.5,13.8288576 18.5,13.001 L18.5,4.999 C18.5,4.17114237 17.8288576,3.5 17.001,3.5 L15,3.5 C14.8673918,3.5 14.7402148,3.44732158 14.6464466,3.35355339 L12.7928932,1.5 Z M10,5.5 C11.9331424,5.5 13.5,7.06685763 13.5,9 C13.5,10.9331424 11.9331424,12.5 10,12.5 C8.06685763,12.5 6.5,10.9331424 6.5,9 C6.5,7.06685763 8.06685763,5.5 10,5.5 Z M10,6.5 C8.61914237,6.5 7.5,7.61914237 7.5,9 C7.5,10.3808576 8.61914237,11.5 10,11.5 C11.3808576,11.5 12.5,10.3808576 12.5,9 C12.5,7.61914237 11.3808576,6.5 10,6.5 Z",
  id: "camera-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "camera-Icon/Global/camera",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "camera-Swatches/DarkGreen",
  transform: "translate(2.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "camera-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#camera-path-1"
})));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.fb361220.svg";
export { ForwardRef as ReactComponent };